<template>
  <div class="form-group">
    <SelectField
      label=""
      :placeholder="placeholder"
      :floatingLabel="false"
      :options="availableApartmentAreas"
      v-model="value__"
      size="md"
      @update:modelValue="change"
    />
  </div>
</template>

<script>
import SelectField from '@/components/ui/form/select';

export default {
  components: { SelectField },
  props: {
    modelValue: {
      // Use modelValue instead of value
      type: Number,
    },
    type: {
      type: String,
      default: 'max',
    },
    activeType: {
      type: String,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
  },
  data() {
    return {
      value__: this.modelValue,
    };
  },
  computed: {
    placeholder() {
      return this.type === 'max' ? 'Max' : 'Min';
    },
    availableApartmentAreas() {
      const areaList = this.activeType !== 'apartment'
        ? this.$store.getters.config.otherArea
        : this.$store.getters.config.apartmentArea;

      if (this.min) return areaList.filter(option => option.value >= this.min)
      else if (this.max) return areaList.filter(option => option.value <= this.max)
      else return areaList;
    },
  },
  watch: {
    modelValue(newValue) {
      this.value__ = newValue;
    },
  },
  methods: {
    change() {
      this.$emit('update:modelValue', this.value__);
    },
  },
};
</script>
